import React, { useEffect, useState } from "react";
import Header from "../../components/Header";
import Footer from "../../components/Footer";
import { useNavigate, Link } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { Helmet } from "react-helmet";
import { toast } from "react-toastify";
import ToastDefault from "../../components/Toast";
import { GetCartListAction, CartDeleteAction , StripePaymentAction , PaypalPaymentAction , PayuPaymentAction } from "../../redux/actions/PaymentActions";
import "./cart.css";

import stripe_logo from '../../assets/images/stripe_logo.png';
import paypal_logo from '../../assets/images/paypal_logo.jpg';
import PayUMoney_logo from '../../assets/images/PayUMoney_logo.jpg';

import stripeImg from '../../assets/images/stripe1.png';
import paypalImg from '../../assets/images/Paypal.png';
import payumoneyImg from '../../assets/images/payumoney.png';

import { loadStripe } from '@stripe/stripe-js';

const stripePromise = loadStripe('pk_test_rGHf4XOFYgWR5VKxzECTzjWk');


type SeoContent = {
  meta_title: string;
  meta_description?: string;
};

const Cart: React.FC = () => {
  const dispatch = useDispatch<any>();
  const navigate = useNavigate();

  const [seoContent, setSeoContent] = useState<SeoContent | null>(null);
  const { loading, status, data, error } = useSelector((state: any) => state.cartDataState || []);
  const { loading_delete, status_delete, data_delete, error_delete } = useSelector((state: any) => state.cartDeleteState || []);

  const [dataList, setDataList] = useState<any[]>([]);
  const [subTotal, setSubTotal] = useState(0);
  const [btnLoading, setBtnLoading] = useState(false);
  const [lineItem, setLineItem] = useState([]);
  const [selectedMethod, setSelectedMethod] = useState("stripe");

  const { loading_stripe, status_stripe, data_stripe, error_stripe } = useSelector((state: any) => state.stripePaymentState || []);
  const { loading_paypal, status_paypal, data_paypal, error_paypal } = useSelector((state: any) => state.paypalPaymentState || []);
  const { loading_payu, status_payu, data_payu, error_payu } = useSelector((state: any) => state.payuPaymentState || []);


  // 👉 Fetch cart on mount
  useEffect(() => {
    dispatch(GetCartListAction({}));
  }, [dispatch]);

  // 👉 Update dataList when redux data changes
  useEffect(() => {
    if (data) {
      setDataList(data);
    }
  }, [data, status, error]);

  // 👉 Recalculate subtotal and line items when dataList changes
  useEffect(() => {
    if (!dataList || dataList.length === 0) {
      setSubTotal(0);
      setLineItem([]); // clear if empty
      return;
    }

    const total = dataList.reduce(
      (sum, item) => sum + (item?.price || 0),
      0
    );
    setSubTotal(total);

    // collect names
    const tempLineItems : any = dataList.map(item => item?.category?.name || " ");
    console.log("tempLineItems : ",tempLineItems)
    setLineItem(tempLineItems);
  }, [dataList]);

  // 👉 Delete cart item
  const deleteCart = (subCategoryId: number) => {
    const confirmDelete = window.confirm(
      "Are you sure you want to remove this item from your cart?"
    );
    if (confirmDelete) {
      dispatch(CartDeleteAction({ delete_id: subCategoryId }));
    }
  };

  // 👉 Handle delete status
  useEffect(() => {
    if (status_delete) {
      dispatch(CartDeleteAction("RESET"));
      dispatch(GetCartListAction({}));
      //toast.success(data_delete?.message || "Item removed from cart");
    }
    if (error_delete) {
      dispatch(CartDeleteAction("RESET"));
    }
  }, [dispatch, status_delete, error_delete, data_delete]);

  // 👉 checkout cart item
  const checkOut = () => {
    console.log("checkOut : ",checkOut)
    setBtnLoading(true);
    if(selectedMethod == "stripe"){
        // Send request to backend to create Stripe checkout session
        dispatch(StripePaymentAction({
            final_amount: subTotal,
            currency: "GBP",
            success_url: window.location.origin+'/payment-confirmation',
            cancel_url: window.location.origin+'/payment-cancelled',
            line_items:lineItem.join(" AND "),
        }))
    } else if(selectedMethod == "paypal"){
      dispatch(PaypalPaymentAction({
          final_amount: subTotal,
          currency_code: "GBP",
          success_url:  window.location.origin+'/payment-confirmation',
          cancel_url: window.location.origin+'/payment-cancelled',
          item_name: lineItem.join(" AND "),
          custom: "",
      }))
    } else if(selectedMethod == "payu"){
      dispatch(PayuPaymentAction({
            txnid: 'TXN' + new Date().getTime(),
            amount: subTotal,
            currency: "GBP",
            success_url: window.location.origin+'/payment-confirmation',
            cancel_url: window.location.origin+'/payment-cancelled',
            productinfo:lineItem.join(" AND "),
      }))
    } else {
        // Send request to backend to create Stripe checkout session
        dispatch(StripePaymentAction({
            final_amount: subTotal,
            currency: "GBP",
            success_url: window.location.origin+'/payment-confirmation',
            cancel_url: window.location.origin+'/payment-cancelled',
            line_items:lineItem.join(" AND "),
        }))
    }
    setTimeout(() => { setBtnLoading(false) }, 5000);
  }

  // 👉 Handle Stripe Checkout Process
  useEffect(() => {
    const redirectToStripe = async () => {

      if (status_stripe && data_stripe) {
        console.log("status_stripe : ",status_stripe)
        const stripe = await stripePromise; // ✅ await the Stripe object
        if (!stripe) {
          toast.error("Stripe failed to initialize.");
          return;
        }

        const { error } = await stripe.redirectToCheckout({
          sessionId: data_stripe.id,
        });

        if (error) {
          console.error("Stripe Error:", error.message);
          toast.error("Stripe Error: " + error.message);
        }
      }

      if (error_stripe) {
        console.error("Stripe Error: ", error_stripe);
        toast.error("Stripe Error: " + error_stripe);
        setBtnLoading(false);
      }
    };
    console.log("status_stripe : ",status_stripe)
    redirectToStripe();
  }, [status_stripe, error_stripe, data_stripe]);

  // 👉 Handle PayPal Checkout Process
  useEffect(() => {
    const handlePaypalRedirect = async () => {
      try {
        console.log("------------------- PayPal Checkout ----------------" ,status_paypal , data_paypal);
        if (status_paypal) {
          // ✅ PayPal success case
          if (data_paypal?.message == "success") {
            const approvalLink = data_paypal.links?.find(
              (link: any) => link.rel === "approval_url"
            )?.href;
            console.log("approvalLink : ",approvalLink)
            if (approvalLink) {
              window.location.href = approvalLink; // Redirect to PayPal checkout
            } else {
              console.error("Approval URL not found in PayPal response");
              toast.error("PayPal Error: Approval URL missing");
            }
          } else {
            // ❌ Handle PayPal error response
            console.error("PayPal Payment Error:", data_paypal?.message);
            toast.error("PayPal Error: " + data_paypal?.message);
          }
        }

        if(error_paypal) {
          console.error("------------------- PayPal Error : 123 ----------------", error_paypal);
          toast.error(error_paypal?.error?.message || "PayPal error occurred");
          // Swal.fire("Warning!", error_paypal?.error?.message || "PayPal error occurred", "error");
          setBtnLoading(false);
        }
      } catch (err) {
        console.error("Unexpected PayPal error:", err);
        toast.error("Unexpected PayPal Error"); 
      }
    };

    handlePaypalRedirect();
  }, [status_paypal, error_paypal, data_paypal]);


  // 👉 Handle PayU Checkout Process
  useEffect(() => {
    const handlePayURedirect = async () => {
      try {
        console.log("------------------- PayU Checkout ----------------");
        if (status_payu && data_payu) {
          // ✅ PayU success case (redirect via form POST)
          if (data_payu?.action && data_payu?.params) {
            const { action, params } = data_payu;

            // Dynamically create a form and submit
            const form = document.createElement("form");
            form.action = action;
            form.method = "POST";

            Object.keys(params).forEach((key) => {
              const input = document.createElement("input");
              input.type = "hidden";
              input.name = key;
              input.value = params[key];
              form.appendChild(input);
            });

            document.body.appendChild(form);
            form.submit();
          } else {
            // ❌ Handle PayU error response
            console.error("PayU Payment Error:", data_payu?.message);
            toast.error("PayU Error: " + (data_payu?.message || "Unknown error"));
          }
        }

        if (error_payu) {
          console.error("------------------- PayU Error ----------------", error_payu);
          toast.error(error_payu?.error?.message || "PayU error occurred");
          setBtnLoading(false);
        }
      } catch (err) {
        console.error("Unexpected PayU error:", err);
        toast.error("Unexpected PayU Error");
      }
    }

    handlePayURedirect();
  }, [status_payu, error_payu, data_payu]);

  return (
    <>
      <Helmet>
        <title>{`${seoContent?.meta_title || "Cart"}`}</title>
        <meta
          name="title"
          content={seoContent?.meta_title || "E-learning Platform"}
        />
        <meta
          name="description"
          content={
            seoContent?.meta_description ||
            "Learn with curated e-learning resources"
          }
        />
        <meta
          name="keywords"
          content="e-learning, tech-cards, cheat-sheets, tutorials"
        />
      </Helmet>

      <Header />

      <div className="page-header">
        <div className="container text-center">
          <h1 className="fw-bold mb-3">Your Shopping Cart</h1>
          <p className="mb-0">Review your selected items before checkout</p>
        </div>
      </div>

      <div className="container">
        <div className="row">
          {/* Cart items */}
          <div className="col-lg-8 mb-4">
            <div className="cart-container">
              {dataList.length > 0 && (
                <h2 className="mb-4">
                  {dataList.length}{" "}
                  {dataList.length === 1 ? "Item" : "Items"} in Cart
                </h2>
              )}

              {dataList.length > 0 ? (
                dataList.map((item: any) => (
                  <div className="cart-item" key={item.id}>
                    <span className="cart-custom-icon">
                      {item?.category?.icon}
                    </span>

                    <div className="cart-item-details">
                      <div className="d-flex justify-content-between align-items-center">
                        {/* Left: Category name */}
                        <h5 className="cart-item-title mb-0">
                          {item?.category?.name}
                        </h5>

                        {/* Right: Group name */}
                        {item?.groups?.name && (
                          <span className="cart-item-group text-muted p-1 order-status status-completed me-2 ">
                            <b>{item.groups.name}</b>
                          </span>
                        )}
                      </div>
                      <p className="cart-item-instructor">
                        {item?.category?.single_line}
                      </p>
                      <div className="d-flex flex-column justify-content-between align-items-stretch">
                        {/* Left: Price */}
                        <span className="cart-item-price fw-semibold text-nowrap">
                          {item?.currency} {item?.price}
                        </span>

                        {/* Right: group name on top, trash on bottom */}
                        <div className="d-flex flex-column justify-content-between align-items-end ">
                          
                          <button
                            className="cart-item-remove btn btn-link p-1"
                            onClick={() => deleteCart(item?.id)}
                            aria-label="Remove from cart"
                          >
                            <i className="bi bi-trash fs-5 text-danger"></i>
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                ))
              ) : (
                <div className="empty-cart text-center">
                  <i className="bi bi-cart-x empty-cart-icon"></i>
                  <h3 className="mb-3">Your cart is empty</h3>
                  <p className="text-muted mb-4">
                    Browse our artifacts and find something to learn!
                  </p>
                  <Link style={{ width: "35%" }} to="/" className="btn btn-primary">
                    Explore Artifacts
                  </Link>
                </div>
              )}


            </div>
          </div>

          {/* Summary */}
          <div className="col-lg-4">
            <div className="summary-card sticky-top" style={{ top: "20px" }}>

              <h3 className="summary-title">Order Summary</h3>
              <div className="summary-row">
                <span>
                  Subtotal ({dataList.length}{" "}
                  {dataList.length === 1 ? "item" : "items"})
                </span>
                <span>
                  {dataList[0]?.currency || ""} {subTotal.toFixed(2)}
                </span>
              </div>

              <div className="summary-row">
                <span>Discount</span>
                <span className="text-success">
                  - {dataList[0]?.currency || ""} 0.00
                </span>
              </div>

              <div className="summary-row summary-total">
                <span>Total</span>
                <span>
                  {dataList[0]?.currency || ""} {subTotal.toFixed(2)}
                </span>
              </div>

              <hr />
              <h3 className="summary-title mb-3">Pay via</h3>

              <div className="payment-options">
                {/* Stripe */}
                <label
                  className={`payment-method ${selectedMethod === "stripe" ? "active" : ""}`}
                  onClick={() => setSelectedMethod("stripe")}
                >
                  <input
                    type="radio"
                    name="paymentMethod"
                    value="stripe"
                    checked={selectedMethod === "stripe"}
                    onChange={() => setSelectedMethod("stripe")}
                  />
                  <div className="payment-method-content">
                    <img src={stripe_logo} alt="Stripe" />
                    <span>Stripe (All currency payments using credit or debit card)</span>
                  </div>
                </label>

                {/* PayPal */}
                <label
                  className={`payment-method ${selectedMethod === "paypal" ? "active" : ""}`}
                  onClick={() => setSelectedMethod("paypal")}
                >
                  <input
                    type="radio"
                    name="paymentMethod"
                    value="paypal"
                    checked={selectedMethod === "paypal"}
                    onChange={() => setSelectedMethod("paypal")}
                  />
                  <div className="payment-method-content">
                    <img src={paypalImg} alt="PayPal" />
                    <span>PayPal (If you want to use PayPal)</span>
                  </div>
                </label>

                {/* PayU */}
                <label
                  className={`payment-method ${selectedMethod === "payu" ? "active" : ""}`}
                  onClick={() => setSelectedMethod("payu")}
                >
                  <input
                    type="radio"
                    name="paymentMethod"
                    value="payu"
                    checked={selectedMethod === "payu"}
                    onChange={() => setSelectedMethod("payu")}
                  />
                  <div className="payment-method-content">
                    <img src={payumoneyImg} alt="PayU Money" />
                    <span>PayU Money (For all INR payments)</span>
                  </div>
                </label>
              </div>

              <button
                disabled={dataList.length === 0}
                className="btn-checkout"
                onClick={checkOut}
              >
                {btnLoading ? (
                  <span
                    className="spinner-border spinner-border-sm me-2"
                    role="status"
                    aria-hidden="true"
                  ></span>
                ) : (
                  <i className="bi bi-lock-fill me-2"></i>
                )}
                Proceed to Checkout
              </button>

              <button onClick={() => navigate(-1)} className="btn-continue">
                <i className="bi bi-arrow-left me-2"></i>Continue Shopping
              </button>

              <div className="mt-4">
                <p className="small text-muted">
                  <i className="bi bi-shield-check me-2"></i>
                  Secure checkout. 6-day money-back guarantee.
                </p>
              </div>
            </div>


          </div>
        </div>
      </div>

      <ToastDefault />
      <Footer />
    </>
  );
};

export default Cart;